export const isDateValid = (date: any) => !(Date.parse(date) !== Date.parse(date));
